const bound = (n, limit) => {
	const { abs, min, max } = Math;
	n = min(limit, max(0, parseFloat(n)));
	if ((abs(n - limit) < 0.000001)) {
		return 1;
	}
	return (n % limit) / parseFloat(limit);
};

const rgb2rgb = rgb => {
	return {
		r: bound(rgb.r, 255) * 255,
		g: bound(rgb.g, 255) * 255,
		b: bound(rgb.b, 255) * 255
	};
};

export const hex2rgb = hex => {
	hex = (hex.charAt(0) === '#') ? hex.slice(1) : hex;
	if (hex.length === 3) {
		hex = hex.charAt(0) + hex.charAt(0) + hex.charAt(1) + hex.charAt(1) + hex.charAt(2) + hex.charAt(2);
	}
	return rgb2rgb({
		r: parseInt(hex.substring(0, 2), 16),
		g: parseInt(hex.substring(2, 4), 16),
		b: parseInt(hex.substring(4, 6), 16)
	});
};


// WEBPACK FOOTER //
// ./src/utils/color.js